import { DEFAULT_META } from "constants/misc";
import { ShipmentStatusCategories } from "constants/shipment-statuses.config";
import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import { SortDirection } from "interfaces/api.interface";
import { IShipment } from "models/shipment/shipment.model";
import { IShipmentsSlice } from "./ShipmentsSlice.interface";

const fromDate = new Date();

const toDate = new Date();

// The manifest range compares full timestamps (unlike the other reports,
// which are date-only), so a From that matches To to the millisecond would
// always produce an empty manifest. Default it to "today so far" instead.
const manifestFromDate = new Date();
manifestFromDate.setHours(0, 0, 0, 0);

export const ShipmentsInitialState: IShipmentsSlice = {
  loadingStatus: ApiLoadingStatus.IDLE,
  loadingRerunRules: ApiLoadingStatus.IDLE,
  selectedShipmentIds: [],
  currentShipmentLoadingStatus: ApiLoadingStatus.IDLE,
  currentShipment: {} as IShipment,
  showMore: false,
  items: [],
  query: {
    offset: 0,
    filters: {
      statuses: ShipmentStatusCategories.READY,
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
      dateRangeField: "created_date",
      trackingStatus: null,
      shipmentStatuses: null,
      storeUpdateStatuses: null,
    },
    sort: {
      createdDate: SortDirection.DESC,
    },
  },
  meta: {
    ...DEFAULT_META,
    statusCount: {
      complete: 0,
      error: 0,
      ready: 0,
      cancelled: 0,
    },
    shipmentIds: [],
  },
  reportShipmentFrom: fromDate.toISOString(),
  reportShipmentTo: toDate.toISOString(),
  reportLabelFrom: fromDate.toISOString(),
  reportLabelTo: toDate.toISOString(),
  manifestShipmentFrom: manifestFromDate.toISOString(),
  manifestShipmentTo: toDate.toISOString(),
  listOfTrackingStatuses: [],
  allIntegrationStores: [],
  allIntegrationStoresLoadingStatus: ApiLoadingStatus.IDLE,
  allCarriers: [],
  allCarriersLoadingStatus: ApiLoadingStatus.IDLE,
  dateRangeDays: "1d",
  bulkShipmentLookupValue: null,
  surchargeReportFrom: fromDate.toISOString(),
  surchargeReportTo: toDate.toISOString(),
  supportDraftResume: null,
};
